;(function () {
    var debug = false;
    var count = 0;
    var sliderProPlugin = "/citytours/js/slider-pro-master/dist/js/jquery.sliderPro.min.js";
    var stickyPlugin = "/citytours/js/theia-sticky-sidebar-master/dist/theia-sticky-sidebar.min.js";
    var resizeSonsor = "/citytours/js/theia-sticky-sidebar-master/dist/ResizeSensor.min.js";

    var clog = function (msg) {
        if (debug) {
            console.log("[CP] " + msg);
        }
    };
    /**
     * Function to load js plugin
     *
     * @param name The name of jQuery plugin. If null, just include.
     * @param url
     * @param success
     */
    var includePlugin = function (name, url, success) {
        if (null !== name) {
            if (jQuery().name) {
                // plugin already included. Do nothing
                return;
            }
        }
        $.getScript(url, function (data, textStatus, jqxhr) {
            success();
        }).done(function (script, textStatus) {

        }).fail(function (jqxhr, settings, exception) {
            console.error("Include " + name + " plugin failed. ");
        });
        return;
    };


    var preInit = function () {
        // wait until jquery is loeaded
        if (!(typeof jQuery === "function")) {
            window.setTimeout(function () {
                count++;
                clog("count = " + count.toString() + "x 10ms");
                preInit();
            }, 10);  // Try again every 10 ms..
            return;
        }

        // jquery is loaded
        $(document).ready(function ($) {
            /**
             * Slider Pro
             */
            includePlugin("sliderPro", sliderProPlugin, function () {
                // success
                clog("sliderPro included");
                /**
                 * https://github.com/bqworks/slider-pro/blob/master/docs/api.md#1-properties
                 */
                var option = {
                    width: 960,
                    height: 580,
                    responsive: true,
                    arrows: true,
                    buttons: false,
                    waitForLayers: true,
                    fade: true,
                    autoplay: false,
                    autoScaleLayers: false
                };
                $('#Img_carousel').sliderPro(option);
            });

            /**
             * Stick Plugin
             *
             */
            includePlugin("stickyPlugin", stickyPlugin, function () {
                clog("stickyPlugin plugin included");
                //
                $(".theiaStickySidebar")
                    .theiaStickySidebar({
                            additionalMarginTop: 94, // 84px is the height of top navi
                            additionalMarginBottom: 0,
                            updateSidebarHeight: false,
                            minWidth: 0,
                            disableOnResponsiveLayouts: false,
                            defaultPosition: "relative",
                            namespace: "TSS"
                        }
                    );
            });


            $.getScript(resizeSonsor, function () {
                clog("Resize sensor included");
            });

            $(".collapse").collapse({
                toggle: false
            });

            function toggleChevron(e) {
                clog("Event: " + e.type);
                $(e.target).closest('.panel-heading').find("i.indicator").toggleClass('icon-plus icon-minus');
            }

            var events = "hidden.bs.collapse shown.bs.collapse";
            events = "show.bs.collapse hide.bs.collapse hidden.bs.collapse shown.bs.collapse click";
            $('a.accordion-toggle').on(events, toggleChevron);


            // add click on cat event
            $("ul#cat_nav > li > a").on("click", function () {
                $("ul#cat_nav > li > a").removeClass("active");
                $(this).addClass("active");
            });

            var clickSimulation = function (obj) {
                if (obj.length > 0) {
                    window.setTimeout(function () {
                        obj.trigger("click");
                    }, 500);
                } else {
                    clog("Can not click element");
                }
            };

            //模拟点击pannel
            var firstPannelTitle = $("div.panel-heading i.indicator").eq(0);
            var secondPannelTitle = $("div.panel-heading i.indicator").eq(1);
            clickSimulation(firstPannelTitle);
            clickSimulation(secondPannelTitle);
        });
    }

    /**
     * Add scroll effect in cat nav
     */
    $('#floatNaviSidebar a[href^="#"]').click(function () {
        if (window.location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            || window.location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                        scrollTop: target.offset().top - 115
                    }, 800,
                    "swing",
                    function (e) {
                        //滚动到指定位置后并打开折叠
                        var panel = $("#" + target.prop("id"));
                        if (panel) {
                            var button = panel.find("a.accordion-toggle");
                            if (button.hasClass("collapsed")) {
                                button.trigger("click");
                            }
                        }
                    }
                );
                return false;
            }
        }
    });

    preInit();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/cruiseProduct.js